module.exports = __webpack_public_path__ + "static/assets/d5fe977d97eca9bf23686f4a320fa29f.png";